import * as React from 'react';

interface IProps {
  onCancelClicked: () => void;
  onSubmitClicked: () => void;
}

export const AddFundsFooterButtons: React.FC<IProps> = ({
  onCancelClicked,
  onSubmitClicked,
}) => {
  return (
    <div className="iras-a-fund-account-footer__action-button-wrapper">
      <div className="iras-a-fund-account-footer__action-button-container">
        <button
          className="iras-a-fund-account-footer__action-button--cancel"
          onClick={onCancelClicked}>
          Previous
        </button>
        <button
          onClick={onSubmitClicked}
          className="iras-a-fund-account-footer__action-button--submit">
          Submit
        </button>
      </div>
    </div>
  );
};
